<div>
  <h2>Help</h2>
  <p>
    This platform/UI is used to upload both 'Single' value and 'Range' value ship method specific transit time for different 'Business use cases'
    and for different granularity level of data, at which Transit time files re stored/acceptable.<br/>
    This Self-Serve Ui currently supports below mentioned business use cases:
  </p>
  <table class="table">
    <thead class="thead-dark table-bordered">
    <tr>
      <th scope="col">#</th>
      <th scope="col">Business Use case</th>
      <th scope="col">User usage</th>
      <th scope="col">Granularity level of data, at which TT files are uploaded/acceptable</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <th scope="row">1</th>
      <td>SBR 2.0 Domestic</td>
      <td>This Business case is used, when user wants to upload/update a Ship
        method specific TT file for Domestic carriers, of their respective market
        places. User should choose "DOM" initially and then either choose
        'NA', 'EU', 'FE' (respective Market places) for this Business Use case</td>
      <td>Ship Method - Zip to Zip<br/>
        [OriginZip level, Destination Zip level]</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>SBR 2.0 OOC</td>
      <td>This Business case is used, when user wants to upload/update a ship
        method specific IT file for 'Out of Country' carriers. User should choose
        "OOC' tab for this use case</td>
      <td>Ship Method - Country to country<br/>
        (Origin Country level, Destination Country level]<br/>
        Ship Method - Country to Zip<br/>
        [Origin Country level, Destination Zip Level]<br/>
        Ship Method - Zip to Zip<br/>
        [OriginZip level, Destination Country level, Destination Zip level]</td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td>SBR 1.0</td>
      <td>This Business case is used, when user wants to upload/update a IT file at
        Country or Carrier level.
        For 'SBR 1.0 - DOM' - User should choose "DOM" and then either choose
        'NA','EU','FE (respective market places)
        FOR 'SBR 1.0 - OOC' - User should choose 'OOC' tab</td>
      <td>Country - Zip to Zip<br/>
        [Origin+ Zip level, Destination + Zip level]<br/>
        Carrier - Zip to Zip<br/>
        [OriginZip level, Destination Zip level]</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td>MFN_INDIA</td>
      <td>This Business case is used, when user wants to upload/update a TT file at</td>
      <td>Merchant ID level<br/>
        Seller - Zip to Zip<br/>
        [OriginZip level, Destination Zip level]</td>
    </tr>
    <tr>
      <th scope="row">5</th>
      <td>DOM_STT</td>
      <td>This Business case is used, when user wants to upload/update a TT file at</td>
      <td>Merchant ID level<br/>
        Seller - Zip to Zip<br/>
        [OriginZip level, Destination Zip level]</td>
    </tr>
    <tr>
      <th scope="row">6</th>
      <td>OOC_STT</td>
      <td>This Business case is used, when user wants to upload/update a TT file at</td>
      <td>Merchant ID level<br/>
        Seller - Zip to Zip<br/>
        [OriginZip level, Destination Zip level]</td>
    </tr>
    </tbody>
  </table>
  <h6><u>Brief Explanation of Tab usage</u></h6>
  <table class="table">
    <thead class="thead-dark table-bordered">
    <tr>
      <th scope="col">Tab/Section</th>
      <th scope="col">Brief explanation of the Tab/Section, used for</th>
    </tr>
    </thead>
    <tbody>

    <tr>
      <td>NEW ONBOARDING REQUESTS</td>
      <td>This tab allows the users to onboard transit time for new carriers/ship methods.</td>
    </tr>
    <tr>
      <td>UPDATE TRANSIT TIME</td>
      <td>This tab contains two features.
        Update Transit Time of entire ship methods/all lanes:
        This feature allows the user to update the Transit time of entire ship method/all
        lanes
        Update Transit time (Pad):
        This feature lets the user to pad the transit time of a particular ship method in Hrs.</td>
    </tr>
    <tr>
      <td>UPDATE VALIDATION THRESHOLD </td>
      <td>
        <b>Threshold</b> - For any transit time update request, delta(percentage change) is calculated between uploaded file & latest production file,
        threshold is a maximum percentage-change/delta between two files such that update request is Auto Approved.
        <br>
        This tab contains two features.
        <br>
        Get All Thresholds : This feature allows the user to get all the configured thresholds & base threshold.
        <br>
        Add Threshold : This feature lets the user to add new thresholds.
      </td>
    </tr>
    <tr>
      <td>DOWNLOAD REPORTS</td>
      <td>This tab is used to download the reports like Lane count Report, Transit time file etc.</td>
    </tr>
    <tr>
      <td>PENDING APPROVAL REQUESTS</td>
      <td>This tab is used to view all the pending approval requests at one place.</td>
    </tr>
    <tr>
      <td>VIEW HISTORY</td>
      <td>This tab lets the user to view previous updated requests, if any.</td>
    </tr>
    </tbody>
  </table>

  <b>For more information, checkout out this <a href="https://w.amazon.com/bin/view/MSTI/TransitTimeSelfServiceTool">Wiki</a></b>
</div>
